import { ClickAwayListener, makeStyles, Tooltip } from '@material-ui/core';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import useCheckMobileScreen from '../../hooks/useWidth';
import { getNamespace } from '../../utils/storage';
import listOfCrumbs from './data';
import { PropTypes } from 'prop-types';
import { useContext } from 'react';
import LanguageContext from '../../contexts/languageContext';
import { getPatient } from '../../redux/Patient/PatientAction';

const styles = makeStyles((theme) => ({
    row: ({ isInTooltip, rtl }) => ({
        // display: 'flex',
        // alignItems: 'center',
        // flexFlow: isInTooltip && 'wrap',
        lineHeight: '2',
        textAlign: rtl ? 'right' : 'left',
        [theme.breakpoints.up(1025)]: {
            position: 'absolute',
            top: '25px',
            zIndex: '1',
            maxWidth: 'calc(100vw - 220px)',
            wordBreak: 'break-word'
        },
        [theme.breakpoints.down(1025)]: {
            fontSize: '12px',
            color: '#545e66'
        },
        display: !isInTooltip && 'block !important',
        whiteSpace: !isInTooltip && 'nowrap',
        textOverflow: !isInTooltip && 'ellipsis',
        overflow: !isInTooltip && 'hidden',
        '& span': {
            textAlign: 'start',
            unicodeBidi: 'plaintext'
        }
    }),
    separator: {
        margin: '0 10px',
        color: '#989ea3'
    },
    customTooltip: {
        background: 'black',
        margin: 0,
        fontSize: '11px'
    },
    customArrow: {
        color: 'black'
    }
}));

const Separator = () => {
    const classes = styles();
    return <span className={classes.separator}>/</span>;
};
const CustomToolTip = ({ children, title }) => {
    const classes = styles();
    CustomToolTip.propTypes = {
        children: PropTypes.any,
        title: PropTypes.string
    };
    return (
        <Tooltip
            title={`id : ${title}`}
            arrow
            classes={{
                tooltip: classes.customTooltip,
                arrow: classes.customArrow
            }}
        >
            {children}
        </Tooltip>
    );
};

const BreadCrumbsView = ({ setIsOverFlow, setOpen, isInTooltip = false }) => {
    const { data } = listOfCrumbs();
    const { lang } = useContext(LanguageContext);
    const classes = styles({ isInTooltip, rtl: lang === 'fa' });
    const { pathname } = useLocation();
    const isMobile = useCheckMobileScreen();
    const params = useParams();
    const nameSpaceId = getNamespace();
    const dispatch = useDispatch();
    const polyclinics = useSelector((state) => state.user?.polyclinics);
    const nameSpace = polyclinics.find((item) => item.id === nameSpaceId);
    const workspace = useSelector((state) => state?.user?.workspace?.clinic);
    const [hasDelay, setHasDelay] = useState(true);
    const isFormPath = pathname?.includes('forms') && !pathname?.includes('newForm') && !isMobile;
    // const splitUrl = pathname.split('/').filter((item) => item)[2];
    const patientId = params?.id;
    const isSelectClinic = pathname?.includes('select-clinic');
    const commonPath = pathname
        ?.split('/')
        ?.filter((item) => item)
        ?.slice(1)
        ?.join('/');
    const patient = useSelector(
        (state) =>
            state?.patient?.patient?.profile ||
            state?.patient?.patient?.overall ||
            state?.appointment?.appointments?.find(
                (val) => val.patient.id.toString() === params?.id
            )?.patient
    );

    useEffect(() => {
        if (params?.id && !patient?.id) {
            dispatch(getPatient(params?.id));
        }
    }, [params?.id, patient]);

    useEffect(() => {
        if (isFormPath) {
            setHasDelay(true);
            setTimeout(() => {
                setHasDelay(false);
            }, 1000);
        }
    }, [pathname]);

    const duplicateUrls = [
        { key: 1, name: nameSpace?.name, id: nameSpace?.id },
        { key: 2, name: workspace?.name, id: workspace?.id }
    ];

    if (!nameSpace?.name || !workspace?.id || (hasDelay && isFormPath)) {
        return null;
    }
    return (
        <>
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <div
                    className={classes.row}
                    onClick={() => setOpen(true)}
                    ref={(ref) => {
                        if (!ref) return;
                        const isOverFlow =
                            ref.offsetHeight < ref.scrollHeight ||
                            ref.offsetWidth < ref.scrollWidth;
                        setIsOverFlow(isOverFlow ? true : false);
                    }}
                >
                    {duplicateUrls.map((item, index) => (
                        <Fragment key={item.key}>
                            <CustomToolTip title={item.id}>
                                <span>{item.name}</span>
                            </CustomToolTip>
                            {((index !== 1 && isSelectClinic) || !isSelectClinic) && <Separator />}
                        </Fragment>
                    ))}
                    {patientId && (
                        <>
                            <CustomToolTip title={patientId}>
                                <span>
                                    {patient?.first_name} {patient?.last_name}
                                </span>
                            </CustomToolTip>
                            <Separator />
                        </>
                    )}
                    {data
                        ?.filter((item) => item.route === commonPath && item.isMobile !== !isMobile)
                        .map((item) => {
                            const lastUrl = item.crumbsList?.length - 1;
                            return (
                                item?.crumbsList?.length &&
                                item.crumbsList.map((crumbsList, index) => (
                                    <Fragment key={index}>
                                        {crumbsList?.tooltip ? (
                                            <CustomToolTip title={crumbsList?.tooltip}>
                                                <span>{crumbsList?.title}</span>
                                            </CustomToolTip>
                                        ) : (
                                            <span>{crumbsList?.title}</span>
                                        )}

                                        {index !== lastUrl && <Separator />}
                                    </Fragment>
                                ))
                            );
                        })}
                </div>
            </ClickAwayListener>
        </>
    );
};
BreadCrumbsView.propTypes = {
    setIsOverFlow: PropTypes.func,
    setOpen: PropTypes.func,
    isInTooltip: PropTypes.bool,
    isOverFlow: PropTypes.bool
};

export default BreadCrumbsView;
